import React from 'react'
import "./ServicesCard.css"
import { FiBriefcase } from "react-icons/fi";

const ServicesCard = ({ details }) => {
  const [role, company] = details.title.split("|").map((item) => item.trim());

  return (
    <div className='work-experience-card'>
        <div className='work-card-header'>
          <span className='work-icon'><FiBriefcase /></span>
          <div>
            <h6>{role || details.title}</h6>
            {company && <p className='work-company'>{company}</p>}
          </div>
        </div>
        <div className='work-duration'>{details.date}</div>

        <ul>
          {details.responsibilities.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
    </div>
  )
}

export default ServicesCard
